import { NotOptedInType } from '../../types/uiTypes';

type ContentProps = {
    uiText: NotOptedInType;
};

const TradeTypeAndPrice = ({ uiText }: ContentProps) => {
    // When the ad does not have a set price, then the trade type text looks bigger
    if (!uiText.priceText) {
        return <h2 className="mb-14 m-0">{uiText.tradeTypeText}</h2>;
    }

    return (
        <div className="mb-24">
            <h2 className="m-0 text-xs s-text">{uiText.tradeTypeText}</h2>
            <p className="m-0 h2">{uiText.priceText}</p>
        </div>
    );
};

export default TradeTypeAndPrice;
